import React from "react"
import {ImportAddList} from "components/backoffice/Transcode/Import/Add/ImportAddList"

export const ImportAddListRoute = (props: any) => {

  return <div>
    <ImportAddList />
  </div>
}